module.exports = __webpack_public_path__ + "img/image_arrow_l.f88fb233.png";